import { render, staticRenderFns } from "./InvestorAccountTab.vue?vue&type=template&id=6ac85793&scoped=true"
import script from "./InvestorAccountTab.vue?vue&type=script&lang=js"
export * from "./InvestorAccountTab.vue?vue&type=script&lang=js"
import style0 from "./InvestorAccountTab.vue?vue&type=style&index=0&id=6ac85793&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac85793",
  null
  
)

export default component.exports